import React, { useEffect } from 'react';
import { RegistrationRedirectError } from '../../components/registration/registration.interface';
import { useDispatch } from 'react-redux';
import { initBaasSignup } from './baasSignupSlice';
import { setRedirectError } from '../redirectError/redirectErrorSlice';
import { signupBaasFromQuery } from './BaasParamsHandler.service';

interface OwnProps {
  children: React.ReactNode;
}

export const BaasSignupParamsHandler: React.FC<OwnProps> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const signup = signupBaasFromQuery();
      dispatch(initBaasSignup(signup));
    } catch (err) {
      const error: RegistrationRedirectError = {
        error: 'application_misconfigured',
        reason: err.message,
      };
      dispatch(setRedirectError(error));
    }
    // eslint-disable-next-line
  }, []);

  return <>{props.children}</>;
};
